import { Paper, Text, Stack, Group } from '@mantine/core'
import { IconArrowsExchange } from '@tabler/icons-react'
import { MarkdownRenderer } from '../common/MarkdownRenderer'

export function RepeatComparison({ comparison }) {
  if (!comparison) return null

  const { attempt_number, changes_observed } = comparison

  return (
    <Paper
      p="lg"
      className="glass"
      style={{
        borderColor: 'rgba(0, 229, 255, 0.15)',
      }}
    >
      <Stack gap="md">
        <Group gap="sm">
          <IconArrowsExchange
            size={18}
            color="var(--mantine-color-cyan-4)"
          />
          <Text
            size="xs"
            ff="Orbitron, sans-serif"
            fw={600}
            c="cyan.4"
            tt="uppercase"
            lts={1}
          >
            Compared to Previous Attempt{attempt_number > 2 ? 's' : ''}
          </Text>
        </Group>

        {changes_observed && (
          <MarkdownRenderer content={changes_observed} />
        )}
      </Stack>
    </Paper>
  )
}
